import React from "react";
import PropTypes from "prop-types";

const amountFormat = new Intl.NumberFormat("es-VE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const rateFormat = new Intl.NumberFormat("es-VE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

const formatRateDate = (date) => (date ? date.split("-").reverse().join("/") : "");

const ratePropType = PropTypes.shape({
  value: PropTypes.number,
  date: PropTypes.string,
  calculated: PropTypes.bool,
});

export const BolivarAmount = ({ iso, value, credit }) =>
  iso && value !== null && value !== undefined ? (
    <div className="fs--2 text-600 fw-normal text-nowrap">
      {`${iso} ${amountFormat.format(value)}`}
      {credit && <small className="ml-1 opacity-40">CR</small>}
    </div>
  ) : null;

BolivarAmount.propTypes = {
  iso: PropTypes.string,
  value: PropTypes.number,
  credit: PropTypes.bool,
};

export const RateLabel = ({ iso, rate, multipleRates }) => {
  if (!iso) return null;
  if (multipleRates) return <span>Varias tasas: cada línea a la tasa de su registro</span>;
  if (!rate) return <span>Sin tasa registrada</span>;

  return (
    <span>
      {`Tasa ${iso} ${rateFormat.format(rate.value)} del ${formatRateDate(rate.date)}`}
      {rate.calculated && <em className="ml-1">(calculada)</em>}
    </span>
  );
};

RateLabel.propTypes = {
  iso: PropTypes.string,
  rate: ratePropType,
  multipleRates: PropTypes.bool,
};

export const RateNote = ({ rate, multipleRates }) => {
  if (multipleRates) return <div className="fs--2 text-500 mt-1">Varias tasas</div>;
  if (!rate) return null;

  return (
    <div className="fs--2 text-500 mt-1">
      {`Tasa ${rateFormat.format(rate.value)}`}
      <span className="d-block">
        {`del ${formatRateDate(rate.date)}`}
        {rate.calculated && <em> · calculada</em>}
      </span>
    </div>
  );
};

RateNote.propTypes = {
  rate: ratePropType,
  multipleRates: PropTypes.bool,
};

export const CalculatedRateNote = () => (
  <div className="px-3 py-2 fs--2 text-600 border-bottom">
    Tasa calculada: el registro no guardó su tasa, así que se usa la registrada para su fecha.
  </div>
);
